export class UpdateStatusImageAppModel {
    imageAppSurrKey: number
    status: boolean
    userEmail: string
  }